import { FC } from 'react';

import { Box } from '@mui/material';

import { TSelection } from 'widgets/regex-editor';

import { TSelectOption } from 'shared/services/types/common.types';

import { SelectionItem } from './slices';

interface IProps {
  selections: TSelection[];
  optionsKeys: TSelectOption[];
  deleteSection: (data: TSelection) => void;
}

export const SectionKeys: FC<IProps> = ({ optionsKeys, selections, deleteSection }) => {
  const selectedNames = new Set(selections.map(item => item.name));

  return (
    <>
      <Box
        display={'flex'}
        gap={'10px'}
        mt={'20px'}
        flexDirection={'column'}
        maxHeight={'500px'}
        overflow={'scroll'}>
        <Box display={'flex'} gap={'10px'} flexDirection={'column'}>
          {selections.map((selection, index) => (
            <SelectionItem
              key={index}
              name={selection.name}
              text={selection.text}
              color={selection.color}
              onRemove={() => deleteSection(selection)}
            />
          ))}
        </Box>

        <Box display={'flex'} gap={'10px'} flexDirection={'column'}>
          {optionsKeys.map(option => {
            const name = option.label;
            if (selectedNames.has(String(option.value))) return null;

            return <SelectionItem key={name} name={String(name)} />;
          })}
        </Box>
      </Box>
    </>
  );
};
